import { render, staticRenderFns } from "./PhaseDiagramViz.vue?vue&type=template&id=0660e256&scoped=true"
import script from "./PhaseDiagramViz.vue?vue&type=script&lang=js"
export * from "./PhaseDiagramViz.vue?vue&type=script&lang=js"
import style0 from "./PhaseDiagramViz.vue?vue&type=style&index=0&id=0660e256&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0660e256",
  null
  
)

export default component.exports